import React, { createContext, useState, useEffect } from 'react';
import io from 'socket.io-client';
import { useAuth } from './AuthContext';
import { getAuthToken } from '../Components/Helpers/script';

// Create a context
const SocketContext = createContext();

// Custom hook to use the socket context
export const useSocket = () => {
  return React.useContext(SocketContext);
};

// Socket provider component
export const SocketProvider = ({ children }) => {
  const [socket, setSocket] = useState(null);
  const [user, setUser] = useState(null);
  const { currentUser } = useAuth();

  useEffect(() => {
    if (currentUser && !user) {
      setUser(currentUser);
    }
  }, [currentUser, user]);

  useEffect(() => {
    if (!user) {
      return;
    }

    getAuthToken(user).then(token => {
      // Connect to Socket.IO server
      const newSocket = io(`${process.env.REACT_APP_API_URL ?? '/'}`, {
        transports: ['websocket', 'polling', 'flashsocket'],
        auth: {
          token: token,
        },
      });

      setSocket(newSocket);

      // Clean up on unmount
      return () => newSocket.close();
    });
  }, [user]);

  return (
    <SocketContext.Provider value={socket}>{children}</SocketContext.Provider>
  );
};
